module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "caldera-config-group"
  }, [(_vm.form.send_local != true) ? _c('label', {
    attrs: {
      "for": _vm.sendLocalIdAttr
    }
  }, [_vm._v("\n\t\t\t\tDisable enhanced delivery for this form\n\t\t")]) : _c('label', {
    attrs: {
      "for": _vm.sendLocalIdAttr
    }
  }, [_vm._v("\n\t\t\t\tEnhanced delivery is disabled for this form\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.send_local),
      expression: "form.send_local"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.sendLocalIdAttr
    },
    domProps: {
      "checked": Array.isArray(_vm.form.send_local) ? _vm._i(_vm.form.send_local, null) > -1 : (_vm.form.send_local)
    },
    on: {
      "change": _vm.changeSendLocal,
      "__c": function($event) {
        var $$a = _vm.form.send_local,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form.send_local = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.form.send_local = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.send_local = $$c
        }
      }
    }
  })])]), _vm._v(" "), (_vm.form.send_local != true) ? _c('div', [_c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.layoutIdAttr
    }
  }, [_vm._v("\n\t\t\t\tEmail Layout\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.layout),
      expression: "form.layout"
    }],
    attrs: {
      "id": _vm.layoutIdAttr
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.layout = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeLayout]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.layouts), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t\t")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.pdfLayoutIdAttr
    }
  }, [_vm._v("\n\t\t\t\tPDF Layout\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pdf_layout),
      expression: "form.pdf_layout"
    }],
    attrs: {
      "id": _vm.pdfLayoutIdAttr
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.pdf_layout = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changePDFLayout]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.layouts), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t\t\t")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.attachPDFIdAttr
    }
  }, [_vm._v("\n\t\t\t\tAttach PDF To Main Mailer\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.attach_pdf),
      expression: "form.attach_pdf"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.attachPDFIdAttr
    },
    domProps: {
      "checked": Array.isArray(_vm.form.attach_pdf) ? _vm._i(_vm.form.attach_pdf, null) > -1 : (_vm.form.attach_pdf)
    },
    on: {
      "change": _vm.changeAttachPDF,
      "__c": function($event) {
        var $$a = _vm.form.attach_pdf,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form.attach_pdf = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.form.attach_pdf = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.attach_pdf = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.attachPDFIdAttr
    }
  }, [_vm._v("\n\t\t\t\tAdd PDF Link\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pdf_link),
      expression: "form.pdf_link"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.attachPDFIdAttr
    },
    domProps: {
      "checked": Array.isArray(_vm.form.pdf_link) ? _vm._i(_vm.form.pdf_link, null) > -1 : (_vm.form.pdf_link)
    },
    on: {
      "change": _vm.changeLinkPDF,
      "__c": function($event) {
        var $$a = _vm.form.pdf_link,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form.pdf_link = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.form.pdf_link = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.pdf_link = $$c
        }
      }
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d44e4582"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/FormSettings/Form.vue
// module id = 235
// module chunks = 1